export const buildTree = (nodes) => {
  let tree = {};
  const nodeMap = new Map();

  // First, map all nodes by their title
  nodes.forEach((node) => {
    nodeMap.set(node.title, { ...node, children: [] });
  });

  // Then, build the tree structure
  nodes.forEach((node) => {
    if (node.parent) {
      const parentNode = nodeMap.get(node.parent);
      if (parentNode) {
        parentNode.children.push(nodeMap.get(node.title));
      } else {
        console.error(`Parent node not found for:`, node);
      }
    } else {
      tree = nodeMap.get(node.title);
    }
  });

  const sortChildren = (node) => {
    if (!node || !node.children) return;
    node.children.forEach((child, index) => {
      if (child.order === undefined) child.order = index;
      sortChildren(child);
    });
    node.children.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  };

  sortChildren(tree);
  calculateTotalAccumulatedPoints(tree); // Call the new function
  return tree;
};

// New recursive function to calculate total accumulated points
const calculateTotalAccumulatedPoints = (node) => {
  if (!node) {
    return 0;
  }

  let accumulatedPoints = node.points || 0; // Start with the node's own points

  if (node.children && node.children.length > 0) {
    node.children.forEach(child => {
      accumulatedPoints += calculateTotalAccumulatedPoints(child); // Add points from children
    });
  }

  node.totalAccumulatedPoints = accumulatedPoints; // Store the sum on the node
  return accumulatedPoints; // Return the sum for recursive calls
};

const findNode = (node, title) => {
  if (node.title === title) return node;
  for (const child of node.children || []) {
    const found = findNode(child, title);
    if (found) return found;
  }
  return null;
};

export const getDescendants = (tree, title) => {
  const targetNode = findNode(tree, title);
  if (!targetNode) return {};

  const descendants = {};

  const traverse = (node) => {
    (node.children || []).forEach((child) => {
      descendants[child.id] = { ...child };
      delete descendants[child.id].children;
      traverse(child);
    });
  };

  traverse(targetNode);
  return descendants;
};

export const getNodeAndDescendants = (tree, title) => {
  const descendants = getDescendants(tree, title);
  if (!descendants) return {};
  descendants[tree.id] = { ...tree };
  delete descendants[tree.id].children;
  return descendants;
};
